import AdultSymptomExercisePage from '@/components/AdultSymptomExercisePage';
import { useLocaleStore } from '@/lib/stores/localeStore';
import { createFileRoute } from '@tanstack/react-router'
import ExerciseImage from "@/assets/exercise-background-photos/anger.png";
import angernMp4 from "@/assets/videos/adults-symptoms/anger/anger.mp4";
import angernWebm from "@/assets/videos/adults-symptoms/anger/anger.webm";
import angerAr from "/subs/anger.ar.vtt";
import angerEn from "/subs/anger.en.vtt";
import { isAdultExerciseGroup } from '@/lib/data/contentCatalog';

export const Route = createFileRoute('/(content)/adults/exercises/anger/')({
  component: RouteComponent,
  validateSearch: (search: Record<string, unknown>) => ({
      group: isAdultExerciseGroup(search.group) ? search.group : undefined,
      mode:
        search.mode === "videos" || search.mode === "exercises"
          ? (search.mode as "videos" | "exercises")
          : undefined,
    }),
    head: () => ({
      meta: [
        {
          title: "Anger - HAMD",
        },
      ],
    }),
    beforeLoad: () => ({
      title: "exercises.categories.anger",
      navbar: {
        transparent: true,
        showTitle: false,
      },
    }),
  });

function RouteComponent() {
   const { group, mode } = Route.useSearch();
    const navigate = Route.useNavigate();
    const locale = useLocaleStore((state) => state.locale);
    const captionsDir: "ltr" | "rtl" = locale === "ar" ? "rtl" : "ltr";
  
    const videos = [
      {
        sources: [
          { src: angernWebm, type: "video/webm" },
          { src: angernMp4, type: "video/mp4" },
        ],
        videoClassName: "w-full h-full object-contain bg-black/40",
        subtitleTracks: [
          { src: angerAr, srcLang: "ar", label: "Arabic", default: true },
          { src: angerEn, srcLang: "en", label: "English" },
        ],
        activeSubtitleLanguage: locale === "ar" ? "ar" : "en",
        captionsDir,
        defaultCaptionsVisible: true,
        showCaptionsToggle: true,
      },
    ];
  
    return (
      <AdultSymptomExercisePage
        symptom="anger"
        titleKey="exercises.categories.anger"
        heroImage={ExerciseImage}
        videos={videos}
        mode={mode}
        onModeChange={(nextMode) =>
          navigate({
            to: Route.to,
            search: {
              mode: nextMode ?? undefined,
              group: nextMode === "exercises" ? group : undefined,
            },
          })
        }
        selectedGroup={group}
        onSelectGroup={(nextGroup) =>
          navigate({
            to: Route.to,
            search: { mode: "exercises", group: nextGroup },
          })
        }
      />
    );
  }
  